import { Padrao } from '../generic/padrao';

export class Moeda extends Padrao{

    override idTab = 9;

    nome: string;
    simbolo: string;
}
